export const getAssetUrlsFromId = (manifest, id) => {
  if (!manifest.assets[id]) {
    return;
  }

  return manifest.assets[id].map(asset => `${manifest.publicPath}${asset}`);
};